import { ApplicationSettings } from "../../services/settings-service";
import { autoinject, computedFrom } from "aurelia-framework";
import { Router } from "aurelia-router";

@autoinject()
export class Banner {
  bannerImageUrl: string;
  isAdminOpen = false;
  classShowMenu: string = "";

  constructor(
    private readonly appSettings: ApplicationSettings,
    private readonly  router: Router) {
    this.bannerImageUrl = appSettings.apiUrl + "/System/GetBannerImage";
  }
  
  toggleAdmin(){
    this.isAdminOpen = !this.isAdminOpen;
  }

  closeAdmin(){
    this.isAdminOpen = false;
  }

  navigate(route: string){
    console.log(route);
    this.router.navigateToRoute(route);
  }

  toggleMenu() {
    if (this.classShowMenu) {
      this.classShowMenu = "";
    } else {
      this.classShowMenu = "show";
    }
  }

  isInternalUser() {
    return this.appSettings.settings.isInternalUser;
  }

  isAdminUser() {
    return this.appSettings.settings.isAdmin && this.isInternalUser();
  }

  get bannerStyle(): string {
    if (this.isInternalUser()) {
      return `background-image: url('${this.bannerImageUrl}')`;
    }
    return `background-image: linear-gradient(rgb(0 83 88 / 70%), rgb(0 83 88 / 70%)), url('${this.bannerImageUrl}')`;
  }
}
